module.exports = __webpack_public_path__ + "img/logo-bandera.bd583185.svg";